<template>
  <a-modal
    title="修改头像"
    :visible="visible"
    :maskClosable="false"
    :confirmLoading="confirmLoading"
    :width="800">
    <a-row>
      <a-col :xs="24" :md="12" :style="{height: '350px'}">
        <vue-cropper
          ref="cropper"
          :img="options.img"
          :info="true"
          :autoCrop="options.autoCrop"
          :autoCropWidth="options.autoCropWidth"
          :autoCropHeight="options.autoCropHeight"
          :fixed="true"
          :fixedBox="options.fixedBox"
          @realTime="realTime"
        >
        </vue-cropper>
      </a-col>
      <a-col :xs="24" :md="12" :style="{height: '350px'}">
        <!--<div class="avatar-upload-preview">-->
        <!--<img :src="previews.url" :style="previews.img"/>-->
        <!--</div>-->
        <div class="avatar-upload-preview" :style="previewStyle">
          <div :style="previews.div">
            <img :src="previews.url" :style="previews.img">
          </div>
        </div>
      </a-col>
    </a-row>

    <template slot="footer">
      <a-upload
        :beforeUpload="beforeUpload"
        id="upload"
        style="float:left;"
        accept="image/png, image/jpeg, image/gif, image/jpg">
        <a-button>
          <a-icon type="upload" /> 选择图片
        </a-button>
      </a-upload>
      <a-button key="back" @click="handleCancel">取消</a-button>
      <a-button key="submit" type="primary" :loading="confirmLoading" @click="handleOk">保存</a-button>
    </template>
  </a-modal>
</template>

<script>
import axios from 'axios'
import { mapActions } from 'vuex'
import { updateAvatar } from '@/api/user'

const instance = axios.create({
  baseURL: 'https://auapi.changhongxs.com/rest-api',
  timeout: 5000,
  headers: {
    'Content-Type': 'multipart/form-data'
  },
  withCredentials: true
})
export default {
  props: {
    userId: {
      type: String,
      required: true
    }
  },

  data () {
    return {
      visible: false,
      confirmLoading: false,
      options: {
        img: '/avatar2.jpg',
        autoCrop: true,
        autoCropWidth: 150,
        autoCropHeight: 150,
        canMove: true,
        canMoveBox: true,
        fixedBox: false
      },
      previews: {},
      previewStyle: {
        width: '150px',
        height: '150px',
        overflow: 'hidden',
        margin: '0',
        zoom: 0.5
      }
    }
  },

  methods: {
    ...mapActions(['SetAvatar']),

    edit (uri, width, height) {
      this.visible = true
      if (uri) {
        this.options.img = uri
      } else {
        this.options.img = require('@/assets/default-avatar.jpg')
      }
      this.options.autoCropWidth = width
      this.options.autoCropHeight = height
    },

    close () {
      // this.options.img = null
      this.visible = false
    },

    handleCancel () {
      this.close()
    },

    handleOk () {
      this.confirmLoading = true
      this.$refs.cropper.getCropBlob((data) => {
        const formData = new FormData()
        formData.append('file', data)
        instance.post('/img', formData).then(response => {
          const res = response.data
          if (res.code === 1) {
            this.doUpdateAvatar(res.data)
          } else {
            this.$message.error(res.msg)
            this.confirmLoading = false
          }
        }).catch(err => {
          console.log(err)
          this.$message.error('图片上传失败!')
          this.confirmLoading = false
        })
      })
    },

    doUpdateAvatar (url) {
      updateAvatar(this.userId, url).then(response => {
        this.SetAvatar(url)
        this.$message.success('头像修改成功')
        this.visible = false
      }).catch(err => {
        console.log(err)
      }).finally(() => {
        this.confirmLoading = false
      })
    },

    realTime (data) {
      // console.log(data)
      this.previews = data
      this.previewStyle = {
        width: this.previews.w + 'px',
        height: this.previews.h + 'px',
        overflow: 'hidden',
        // margin: '5px',
        zoom: (150 / this.previews.h)
      }
    },

    beforeUpload (file) {
      if (!/\.(gif|jpg|jpeg|png|bmp|GIF|JPG|PNG)$/.test(file.name)) {
        this.$message.error('图片类型应符合.gif | jpeg | jpg | png | bmp等格式')
        return false
      }
      this.options.img = window.URL.createObjectURL(new Blob([file]))
      this.options.autoCropWidth = 150
      this.options.autoCropHeight = 150
      return false
    },

    uploadImg (e) {
      const file = e.target.files[0]
      if (!/\.(gif|jpg|jpeg|png|bmp|GIF|JPG|PNG)$/.test(e.target.value)) {
        this.$message.error('图片类型应符合.gif | jpeg | jpg | png | bmp等格式')
        return false
      }
      const reader = new FileReader()
      reader.onload = e => {
        let data
        if (typeof e.target.result === 'object') {
          data = window.URL.createObjectURL(new Blob([e.target.result])) // 把Array Buffer转化为blob 如果是base64不需要
        } else {
          data = e.target.result
        }
        this.options.img = data
      }
      reader.readAsArrayBuffer(file)
      this.options.autoCropWidth = 150
      this.options.autoCropHeight = 150
    }
  }
}
</script>

<style lang="less" scoped>

  .avatar-upload-preview {
    position: absolute;
    top: 50%;
    transform: translate(50%, -50%);
    width: 180px;
    height: 180px;
    border-radius: 50%;
    box-shadow: 0 0 4px #ccc;
    overflow: hidden;

    img {
      width: 100%;
      height: 100%;
    }
  }
</style>
